import FrontBusiness from "@/business/FrontBusiness.js";
import Http from "@/commons/Http";
import ValidationUtils from "@/commons/ValidationUtils.js";

const path = 'api/tarefa';

export default {

    nomearEntidade(tarefa, code = true){
        return `Tarefa ${code ? FrontBusiness.formatarCodigo(tarefa?.codigo) : ''}`;
    },

    async paginationV2(sort, direction, page, size, filters = {}){
        return Http.post(`${path}/v2/pagination?sort=${sort || 't.codigo'},${direction || 'desc'}&page=${page || 1}&size=${size || 10}`, filters);
    },

    async getById(tarefa){
        return Http.get(`${path}/${tarefa}`);
    },

    async save(dto, id = ''){
        return Http.post(`${path}/${id}`, dto);
    },

    salvarAdiamento(tarefa, dto) {
        return Http.post(`${path}/${tarefa}/salvar-adiamento`, dto);
    },

    async buscarPorCodigos(codigos) {
        if (!ValidationUtils.validateLongArray({values: codigos, min: 0, max: 99999999})) {
            throw 'Intervalo Inválido';
        }
        return Http.post(`${path}/codigos`, codigos);
    },

    async clonar(id) {
      return Http.post(`${path}/${id}/clonar`);
    },

    async listarTarefasDisponiveis(etapa){
      return Http.get(`${path}/listar-tarefas-disponiveis/${etapa}`);
    },

    async solicitar(qtd= 1, forcarUrgentes = false, etapa){
      return Http.get(`${path}/${qtd}/solicitar${forcarUrgentes ? '/urgente' : etapa ? '/'+etapa : ''}`);
    },

}
